import React, { useRef, useEffect } from "react";
import Checkbox from "../Checkbox";
import styles from "./CheckboxListDropdown.module.css";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import SearchBar from "../SearchBar";

/**
 * Interactive component. A dropdown that displays a list of checkboxes when open. Clicking on the dropdown toggles the visibility of its children.
 */
export function CheckboxListDropdown({
  dropdownText,
  dropdownOptions,
  checkedOptions,
  setCheckedOptions,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [hasScrollBar, setHasScrollBar] = useState("");
  const listRef = useRef(null);

   useEffect(() => {
     if (listRef.current) {
       const { scrollHeight, clientHeight } = listRef.current;
       setHasScrollBar(scrollHeight > clientHeight);
     }
   }, [dropdownOptions, isOpen]);

   const searchFiltering = dropdownOptions.filter((option) => option.toLowerCase().includes(searchText.toLowerCase()) );

  return (
    <div>
      <button
        className={styles.dropdown}
        type="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {dropdownText}
        <span>
          <FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronRight} />
        </span>
      </button>
      {isOpen && hasScrollBar && (
        <div className={styles.searchBar}>
          <SearchBar
            placeholderText={"Search"}
            onInput={(text) => setSearchText(text)}
            searchDelay={0}
            minChar={0}
          />
        </div>
      )}
      <ul
        ref={listRef}
        className={classNames(styles.list, {
          [styles.hidden]: !isOpen,
        })}
      >
        {searchFiltering.map((option, index) => (
          <Checkbox
            key={index}
            value={option}
            isChecked={checkedOptions.includes(option)}
            setCheckedList={setCheckedOptions}
          />
        ))}
      </ul>
    </div>
  );
}

CheckboxListDropdown.propTypes = {
  /**
   * The text that displays on the dropdown menu bar.
   */
  dropdownText: PropTypes.string,
  /**
   * An array of checkbox values that appear when the menu is open.
   */
  dropdownOptions: PropTypes.arrayOf(PropTypes.string),
  /**
   * An array of checkbox values that are checked.
   */
  checkedOptions: PropTypes.arrayOf(PropTypes.string),
  /**
   * Function that controls the checkedOptions prop.
   */
  setCheckedOptions: PropTypes.func,
};
